import {
  useGetUniversalSearchPopularJobsQuery,
  useGetUniversalSearchPopularTalentQuery,
} from "@js/apps/universal-search/api";

import type { UniversalTabValue } from "../constants";
import { useDebouncedUniversalSearchPhrase } from "../universal-search-slice";

export const useUniversalSearchPopularSearches = ({
  currentTab,
  open,
}: {
  currentTab: UniversalTabValue;
  open: boolean;
}) => {
  const search = useDebouncedUniversalSearchPhrase();
  const commonSkip = !!search || !open;
  const {
    data: popularJobsResult,
    isLoading: isLoadingPopularJobsResult,
    isFetching: isFetchingPopularJobsResult,
  } = useGetUniversalSearchPopularJobsQuery(
    {},
    { skip: commonSkip || currentTab !== "JOBS" },
  );
  const {
    data: popularTalentResult,
    isLoading: isLoadingPopularTalentResult,
    isFetching: isFetchingPopularTalentResult,
  } = useGetUniversalSearchPopularTalentQuery(
    {},
    { skip: commonSkip || currentTab !== "PEOPLE" },
  );

  return {
    popularData: {
      jobResults: popularJobsResult,
      talentResults: popularTalentResult,
    },
    isLoadingPopularData:
      isLoadingPopularJobsResult || isLoadingPopularTalentResult,
    isFetchingPopularData:
      isFetchingPopularJobsResult || isFetchingPopularTalentResult,
  };
};
